import { render, staticRenderFns } from "./show-opportunity.vue?vue&type=template&id=c4e92ffa&"
import script from "./show-opportunity.vue?vue&type=script&lang=js&"
export * from "./show-opportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports